export const LIST_NORMAL_DESCRIPTION_REQUEST = 'LIST_NORMAL_DESCRIPTION_REQUEST'
export const LIST_NORMAL_DESCRIPTION_SUCCESS = 'LIST_NORMAL_DESCRIPTION_SUCCESS'
export const LIST_NORMAL_DESCRIPTION_FAILURE = 'LIST_NORMAL_DESCRIPTION_FAILURE'

export const LIST_NORMAL_DESCRIPTION_SUMMARY_REQUEST = 'LIST_NORMAL_DESCRIPTION_SUMMARY_REQUEST'
export const LIST_NORMAL_DESCRIPTION_SUMMARY_SUCCESS = 'LIST_NORMAL_DESCRIPTION_SUMMARY_SUCCESS'
export const LIST_NORMAL_DESCRIPTION_SUMMARY_FAILURE = 'LIST_NORMAL_DESCRIPTION_SUMMARY_FAILURE'

export const CREATE_NORMAL_DESCRIPTION_REQUEST = 'CREATE_NORMAL_DESCRIPTION_REQUEST'
export const CREATE_NORMAL_DESCRIPTION_SUCCESS = 'CREATE_NORMAL_DESCRIPTION_SUCCESS'
export const CREATE_NORMAL_DESCRIPTION_FAILURE = 'CREATE_NORMAL_DESCRIPTION_FAILURE'

export const DETAIL_NORMAL_DESCRIPTION_REQUEST = 'DETAIL_NORMAL_DESCRIPTION_REQUEST'
export const DETAIL_NORMAL_DESCRIPTION_SUCCESS = 'DETAIL_NORMAL_DESCRIPTION_SUCCESS'
export const DETAIL_NORMAL_DESCRIPTION_FAILURE = 'DETAIL_NORMAL_DESCRIPTION_FAILURE'

export const UPDATE_NORMAL_DESCRIPTION_REQUEST = 'UPDATE_NORMAL_DESCRIPTION_REQUEST'
export const UPDATE_NORMAL_DESCRIPTION_SUCCESS = 'UPDATE_NORMAL_DESCRIPTION_SUCCESS'
export const UPDATE_NORMAL_DESCRIPTION_FAILURE = 'UPDATE_NORMAL_DESCRIPTION_FAILURE'

export const DELETE_NORMAL_DESCRIPTION_REQUEST = 'DELETE_NORMAL_DESCRIPTION_REQUEST'
export const DELETE_NORMAL_DESCRIPTION_SUCCESS = 'DELETE_NORMAL_DESCRIPTION_SUCCESS'
export const DELETE_NORMAL_DESCRIPTION_FAILURE = 'DELETE_NORMAL_DESCRIPTION_FAILURE'

export const RESET_STATE_NORMAL_DESCRIPTION = 'RESET_STATE_NORMAL_DESCRIPTION'

